import enums from "./../enums";

const coupons = (
	state = {
		couponHistory: {
			coupons: [],
		},
		couponLoading: false,
	},
	{ type, payload }
) => {
	switch (type) {
		case enums.COUPON_LOADING: {
			return { ...state, couponLoading: payload };
		}
		case enums.COUPON_HISTORY_LOADED: {
			let couponHistory = { ...state.couponHistory };
			if (payload.isUpdate) {
				couponHistory = {
					...couponHistory,
					coupons: [...couponHistory.coupons, ...payload.coupons],
					offset: payload.offset,
				};
			} else {
				couponHistory = payload;
			}
			return { ...state, couponHistory };
		}

		default:
			return { ...state };
	}
};

export default coupons;
